import React from 'react';
import { useSelector } from 'react-redux';
import { PasswordInput } from '../../register/components/PasswordInput';

export const LoginForm = ({ email, password, onChange, onSubmit }) => {

    const { error, loading } = useSelector(state => state.ui); 

    return (    
        <>
            {error && (
                <div className="alert alert-danger mt-3" role="alert">
                    {error}
                </div>
            )}
            <form onSubmit={onSubmit} className="w-100 mt-4 pt-2">
                <div className="mb-4">
                    <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Correo electrónico"
                        value={email}
                        onChange={onChange}
                        required
                    />
                </div>
                <div className="mb-3">
                    <PasswordInput
                        name="password"
                        placeholder="Contraseña"
                        value={password}
                        onChange={onChange}
                        showGenerator={false}
                    />
                </div>
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <a href="/auth/recovery" className="fs-11 text-primary">¿Olvidaste tu contraseña?</a>
                    </div>
                </div>
                <div className="mt-5">
                    <button type="submit" className="btn btn-lg btn-primary w-100" disabled={loading}>Iniciar sesión</button>
                </div>
            </form>
        </>
    );
}